import React from 'react';
import { Box, Heading } from '@chakra-ui/layout';

const SubContent = ({ value }) => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" mt={4}>
      <Heading
        as="h1"
        size="xl"
        color="orange.500"
        p={4}
        borderRadius="2xl"
        transition=".1s linear"
        borderWidth="4px"
        borderColor="transparent"
        _hover={{
          borderColor: 'blue.200',
          backgroundColor: 'rgba(0,0,0,0.5)',
          color: 'orange',
        }}
      >
        {value}
      </Heading>
    </Box>
  );
};

export default SubContent;
